import { Alert, AlertTitle, styled } from '@mui/material';
import { ErrorOutline as ErrorOutlineIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { useReservationFormMachines } from '../ReservationFormMachinesContext';
import { LevelOfCareContext } from '../machines/levelOfCare.machine';
import { useFieldActorSnapshot } from '../hooks/useFieldActorSnapshot';
import { usePortalContext } from '@/contexts/PortalProvider';

const StyledMessage = styled(Alert)(({ theme }) => ({
  maxWidth: 400,
  transition: 'all 0.2s ease-in-out',
}));

const CareLevelMismatchMessage = ({ index }: { index: number }) => {
  const { t } = useTranslation('common');
  const { isMemberPortal } = usePortalContext();
  
  const { fieldRefs } = useReservationFormMachines();
  const levelOfCareActor = fieldRefs.levelOfCare;
  const levelOfCareSnapshot = useFieldActorSnapshot(levelOfCareActor);
  const { isCareLevelMismatch } =
    levelOfCareSnapshot.context as LevelOfCareContext;

  if (!isCareLevelMismatch[index]) {
    return null;
  }

  return (
    <StyledMessage
    icon={
      isMemberPortal ? (
        <ErrorOutlineIcon color="warning" />
      ) : (
        <ErrorOutlineIcon color="info" />
      )
    }
    severity={isMemberPortal ? 'warning' : 'info'}>
      <AlertTitle>
        <strong>
        {isMemberPortal
          ? t('reservation.careLevelMismatchTitle')
          : t('reservation.careLevelMismatchTitleAdmin')}
        </strong>
      </AlertTitle>
      {isMemberPortal
        ? t('reservation.careLevelMismatchMessage')
        : t('reservation.careLevelMismatchMessageAdmin')}
    </StyledMessage>
  );
};

export { CareLevelMismatchMessage };
